import { useLocalStore } from 'mobx-react';
import { members as membersModel, simultaneousInterpretation } from '@/models';
export interface InterpreterAudioStatusChangeResp {
  interpreterYxMeetingUid: number;
  mikeStatus: number;
}

export default function useInterpreterAudioStatusChange() {
  const { members, simultaneous } = useLocalStore(() => {
    return {
      simultaneous: simultaneousInterpretation,
      members: membersModel,
    };
  });

  const change = async (body: InterpreterAudioStatusChangeResp) => {
    const { interpreterYxMeetingUid, mikeStatus } = body;
    members?.setInterpretersAudioStatus(String(interpreterYxMeetingUid), mikeStatus === 1);
    simultaneous.setMainChannelVolumeComplement();
  };

  return change;
}
